import React, {FC} from "react"
import {UserSavingsBrand, UserSavingsCategories} from "@irati/types"
import MySavingsCard from "./MySavings"
import MyFavouriteBrands from "./MyFavouriteBrands"
import {WidgetsContainer} from "./styles"
import CategoriesChart from "./CategoriesChart"

interface Props {
  showWidgetInPage?: boolean
  brands?: UserSavingsBrand[]
  currency: string
  categories?: UserSavingsCategories[]
}

const SavingsWidgets: FC<Props> = ({showWidgetInPage, brands, currency, categories}) => {
  return (
    <WidgetsContainer gap={3} marginBottom={3}>
      <MySavingsCard showWidgetInPage={showWidgetInPage} />
      <MyFavouriteBrands brands={brands} currency={currency} />
      <CategoriesChart categories={categories} />
    </WidgetsContainer>
  )
}

export default SavingsWidgets
